import React from 'react';
import { makeClassName } from '@siteless/util';

const ParagraphShortIcon = ({
  className,
  ...rest
}: {
  className?: string;
  [x: string]: any;
}) => (
  <svg
    className={makeClassName('ParagraphShortIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
    {...rest}
  >
    <line x1="21" y1="10" x2="3" y2="10" fill="none" />
    <line x1="17" y1="14" x2="3" y2="14" fill="none" />
  </svg>
);

export default ParagraphShortIcon;
